import { InvoiceModel } from './invoice.model';

export class InvoiceFactory {
  public static new(data?: Partial<InvoiceModel>): InvoiceModel {
    return new InvoiceModel(data);
  }

  public static getModel(): any {
    return InvoiceModel;
  }

  public static getPath(): string {
    return 'invoices';
  }
}
